import RiepilogoEventi from "../";

const routes = [
  { name: "RiepilogoEventi", path: "/riepilogoeventi", component: RiepilogoEventi.RiepilogoEventi, meta: { title: "Riepilogo Eventi" } },

 
];
export default routes;
